import { css } from '@emotion/css';

export const filterValueStyle = css`
  width: 20rem;
  min-width: 20rem;
  .arrow-ios-down {
    width: 2rem !important;
    height: 2rem !important;
  }
  .number-input input {
    width: 100% !important;
  }
`;

export const dynamicTimeWidth = css`
  width: 36rem;
`;

export const numberInputStyles = css`
  .MuiInputBase-input {
    text-overflow: ellipsis;
  }
  min-width: 50%;
`;
